import script from "./BrowseView.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowseView.vue?vue&type=script&setup=true&lang=js"

import "./BrowseView.vue?vue&type=style&index=0&id=4b02e822&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b02e822"]])

export default __exports__